/**
 * Returns whether the current platform is macOS/iOS, which uses Cmd (Meta)
 * rather than Ctrl as the primary shortcut modifier.
 *
 * Relies on user-agent sniffing, which MDN flags as unreliable, but there is no
 * robust cross-browser alternative: `navigator.userAgentData` is unsupported in
 * Safari and Firefox, and `navigator.platform` is deprecated.
 * @internal
 */
export function isMacPlatform(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    navigator.userAgent.toLowerCase().includes('mac')
  );
}

/**
 * Matches any string that contains "safari" but does NOT contain "chrome" or "android" before "safari".
 * This distinguishes real Safari from Chrome and Android browsers, which also include "Safari" in their user agent string for compatibility.
 * @returns true if the current browser is Safari, false otherwise
 * @internal
 */
export function isSafari(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
}

/**
 * Checks if the current browser is Firefox.
 * @returns true if the current browser is Firefox, false otherwise
 * @internal
 */
export function isFirefox(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    navigator.userAgent.toLowerCase().includes('firefox')
  );
}
